module.exports = __webpack_public_path__ + "img/12_92.0b4f6f3e.png";